function convertBytes(bytes = 0, unit = "MB") {
  let result = 0;

  switch (unit) {
    case "KB":
      result = bytes / 1024;
      break;
    case "MB":
      result = bytes / (1024 * 1024);
      break;
    case "GB":
      result = bytes / (1024 * 1024 * 1024);
      break;
    default:
      throw new Error("Invalid drive. Use KB, MB or GB.");
  }

  return `${result.toFixed(2)} ${unit}`;
}

export default convertBytes;
